import angular from 'angular';

module.exports = angular.module('market.components', [
  require('./hvr-charts'),
  require('./od-buyer-faqs'),
  require('./od-buyer-listing-info'),
  require('./od-clipboard-copy'),
  require('./od-collapsible-question'),
  require('./od-facebook-share-button'),
  require('./od-footer'),
  require('./od-footer-nonmarketing'),
  require('./od-header'),
  require('./od-incrementor'),
  require('./od-listing-card'),
  require('./od-listing-card-mini'),
  require('./od-listing-filter-form'),
  require('./od-listing-status'),
  require('./od-loading-text'),
  require('./od-lory-carousel'),
  require('./od-brokerage-info'),
  require('./od-press-coverage'),
  require('./od-repair-item'),
  require('./od-signin'),
  require('./od-signup'),
  require('./od-sticky-element'),
  require('./od-story-card-mini'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/index.js
 **/